
        var result = require("!!../../../node_modules/css-loader/index.js!./order.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order.component.css
// module id = 489
// module chunks = 2